let constants = (function () {
	function init() {
		return {
			REQUIRED: "This field is required.",
			MIN_LENGTH: 8, // Minimum length for fields that require a certain number of characters
			MAX_LENGTH: 100, // Maximum length for fields
			MAX_LENGTH_TEL: 100, // Maximum length for fields
			MAX_LENGTH_TEXTAREA: 1000, // Maximum length for fields
			TELEPHONE_MESSAGE: "Please enter a valid telephone number with a minimum of 8 digits.",
		};
	}

	return init();
})();

export default constants;
